import React, { useState, useEffect } from "react";
import "plugins/Lexical/styles.css";
import Form from "react-bootstrap/Form";
import DismissableModal from "components/DismissableModal";
import { compareDates } from "services/MomentUtils";
import { FormSelect } from "react-bootstrap";
import WfItemNote from "./WfItemNote";
import Noter from "./Noter";

const NotesModal = (props) => {
  const [notes, setNotes] = useState(props.notes);
  const [type, setType] = useState("All");

  useEffect(() => {
    setNotes(props.notes);
  }, [props.notes]);

  const typeFilter = (event) => {
    const selectedType = event.target.value;
    setType(selectedType);
    setNotes(
      selectedType !== "All"
        ? props.notes.filter((note) => note.type === selectedType)
        : props.notes
    );
  };

  return (
    <DismissableModal
      openModalButtonText="Show All"
      openModalButtonSize="sm"
      openModalButtonStyle="light"
      title="Notes and Comments"
      centered
    >
      {props.filtersList ? (
        <div className="pull-right rm-notes-filter-container">
          <Form.Label className="rm-notes-filter-label">
            Select Note Type:{" "}
          </Form.Label>
          <FormSelect
            className="pull-right rm-notes-filter-select"
            onChange={typeFilter}
            value={type}
          >
            <option value="All" key="all-filter">
              All
            </option>
            {props.filtersList.map((type, i) => (
              <option value={type} key={i}>
                {type}
              </option>
            ))}
          </FormSelect>
          <hr />
        </div>
      ) : null}
      <div style={{ padding: "0 15px" }}>
        {notes.map((note, idx) => {
          return (
            <span key={idx}>
              <WfItemNote note={note} clipped={false} />
              {idx !== notes.length - 1 ? <hr /> : null}
            </span>
          );
        })}
      </div>
    </DismissableModal>
  );
};

const Notes = ({
  notes: initialNotes,
  entityId,
  entitySaveUrl,
  filtersList,
  noOfNotesToShow = 2,
}) => {
  const [notes, setNotes] = useState(initialNotes);

  useEffect(() => {
    setNotes(initialNotes);
  }, [initialNotes]);

  const addNote = (note) => {
    const newNotes = [...notes];
    newNotes.forEach((n) => (n.new = false));
    note.new = true;
    newNotes.push(note);
    setNotes(newNotes);
  };

  const sortedNotes = [...notes].sort((n1, n2) =>
    compareDates(n2.creationDate, n1.creationDate)
  );

  return (
    <div>
      <div className="small-label">notes and comments ({sortedNotes.length})</div>
      <div className="rm-notes">
        {sortedNotes.length > 0 ? (
          <span>
            {sortedNotes.map((note, idx) => {
              if (idx < noOfNotesToShow) {
                return <WfItemNote note={note} key={idx} clipped={true} />;
              } else return null;
            })}
            <NotesModal notes={sortedNotes} filtersList={filtersList} />
          </span>
        ) : (
          <div className="text-muted tiny-top-spacer">
            No notes have been added
          </div>
        )}
        <Noter
          entityId={entityId}
          onNewNote={addNote}
          entitySaveUrl={entitySaveUrl}
        />
      </div>
    </div>
  );
};

export default Notes;